module.exports = __webpack_public_path__ + "img/LTE.114556e1.svg";